export default __webpack_public_path__ + "static/media/plus.6056afc2.svg";